import { TimerIcon } from 'lucide-react';

import { Timer, TimerHours, TimerMinutes, TimerSeconds, TimerSeparator } from '@/components/ui/timer';

interface QuizTimerProps {
  //in sec
  remainingTime: number;
  isSectionTimer: boolean;
}

export default function QuizTimer(quizTimerProps: QuizTimerProps) {
  const { remainingTime, isSectionTimer } = quizTimerProps;

  const seconds: number = remainingTime % 60;
  const minutes: number = Math.floor(remainingTime / 60) % 60;
  const hours: number = Math.floor(remainingTime / 3600);

  const timeObject = { seconds, minutes, hours };

  return (
    <div className="flex items-center gap-2">
      <TimerIcon className="text-icon-tertiary h-4 w-4" />
      <span className="text-text-tertiary text-xs">Pozostały czas {isSectionTimer ? 'sekcji' : 'quizu'}:</span>
      <Timer formatString="HH:mm:ss" autoUpdate={false} direction="down" time={timeObject}>
        <TimerHours className={'data-[urgent=true]:bg-fill-destructive data-[urgent=true]:text-text-on-destructive-fill'} />
        <TimerSeparator>:</TimerSeparator>
        <TimerMinutes className={'data-[urgent=true]:bg-fill-destructive data-[urgent=true]:text-text-on-destructive-fill'} />
        <TimerSeparator>:</TimerSeparator>
        <TimerSeconds className={'data-[urgent=true]:bg-fill-destructive data-[urgent=true]:text-text-on-destructive-fill'} />
      </Timer>
    </div>
  );
}
